<template>
  <CauHinhBaoMatOtp />
</template>

<script>
import CauHinhBaoMatOtp from "@/components/pages/quan-tri-he-thong/CauHinhBaoMatOtp.vue";
import { setBreadcrumb } from "@/utils/commonUtils";
import { MENU_ROUTE_NAME } from "@/constants/constants";

// Phase 7B-1 UC13: wrapper route cho màn cấu hình bảo mật OTP.
export default {
  name: "TrangCauHinhBaoMatOtp",
  components: {
    CauHinhBaoMatOtp,
  },
  created() {
    setBreadcrumb(`${MENU_ROUTE_NAME.QUAN_TRI_HE_THONG.CAU_HINH_OTP}`);
  },
};
</script>
